function isEmptyValue(value: any) {
	return value === '' || value === undefined || value === null;
}

export default isEmptyValue;
